import {ID, Response} from '../../../../../../../_metronic/helpers'
export type User = {
  id?: ID
  name?: string
  avatar?: string
  email?: string
  username?: string
  firstname?: string
  lastname?: string
  position?: string
  role?: string
  last_login?: string
  two_steps?: boolean
  joined_day?: string
  online?: boolean
  initials?: {
    label: string
    state: string
  }
}

export type UsersQueryResponse = Response<Array<User>>

export const initialUser: User = {
  avatar: 'avatars/300-6.jpg',
  position: 'Art Director',
  role: 'Administrator',
  name: '',
  email: '',
}

export interface IUsers {
  id?: ID
  uuid?: string
  username?: string
  firstname?: string
  lastname?: string
  email?: string
  password?: string
  confirm_password?: string
  device_name?: string
}

export const UsersInitValues: IUsers = {
  username: '',
  firstname: '',
  lastname: '',
  email: '',
  password: '',
  confirm_password: '',
  device_name: '',
}

export interface EvaluationReport {
  id?: number
  uuid?: string
  property_id: number
  type?: 'annual_servitude' | 'single_servitude' | 'direct_damage' | 'business_interruption'
  status?: 'opened' | 'concluded' | 'canceled'
  reference_year?: number
  evaluation_report_number?: string
  observations?: string
  issue_date?: string
  revision_number?: number
  cancellation_reason?: string
  discount?: string
  finished?: boolean
  property?: {
    id?: number
    uuid?: string
    project_id?: number
    name?: string
    identifier?: number
  }
  costCenter?: [
    {
      id?: number
      uuid?: string
      name?: string
      description?: string
    }
  ]
}

export type EvaluationReportQueryResponse = Response<Array<EvaluationReport>>

export const EvaluationReportInitValues: EvaluationReport = {
  property_id: 0,
}
